import React, { Fragment } from 'react';
import { ThemeProvider } from '@mui/material';

import { Header } from '../common';
import JournalNav from './JournalNav';
import { journalTheme } from '../../utils/consts/journalTheme';
import './journal.css';

/**
 * Общий каркас разделов журнала.
 *
 * Отступ сверху обязателен: шапка выходит за границы своего блока
 * (логотип со смещением 55px, навигация высотой 170px внутри 80px) — контент,
 * поставленный сразу после неё, наезжает на логотип. Остальные страницы решают это
 * тем же способом, `.statsBlock` с отступом 80px.
 *
 * Header оставлен вне ThemeProvider: у него собственное оформление,
 * и тема журнала не должна перекрашивать общую навигацию.
 */
const JournalLayout = ({ activeTab, children }) => (
  <Fragment>
    <Header />

    <ThemeProvider theme={journalTheme}>
      <div className="journal-layout">
        <JournalNav activeTab={activeTab} />
        <div className="journal-content">{children}</div>
      </div>
    </ThemeProvider>
  </Fragment>
);

export default JournalLayout;
